import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpEventType } from '@angular/common/http';
import { EncryptDecryptService } from 'src/app/services/services.index';

import { Observable, catchError, map, mergeMap, switchMap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { debug } from 'console';

@Injectable()
export class EncryptDecryptAuthInterceptor implements HttpInterceptor {
    constructor(private encryptDecryptService: EncryptDecryptService, ) {}

    private shouldSkipPathIdEncryption(pathname: string): boolean {
      return pathname.includes('/api/Document/version/') || /\/api\/Document\/\d+$/.test(pathname);
    }

    ExcludeURLList = [
        environment.baseUrl + "/api/Common/commonFileuploaddata",
        environment.baseUrl + "/api/Users/UploadProfilePicture",
        environment.baseUrl + "/api/Common/downloadattachedfile",
        environment.baseUrl + "/api/AssemblyConsultation/validate-excel",
        environment.baseUrl + "/api/AssemblyConsultation/process-excel"
    ];
    intercept(req: HttpRequest < any > , next: HttpHandler): Observable < HttpEvent < any >> {

        let exludeFound = this.ExcludeURLList.filter(element => {
            return req.url.includes(element);
          });

          const securityHeaders = {
            'Content-Security-Policy': "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; object-src 'none'",
            'X-Content-Type-Options': 'nosniff',
            'X-Frame-Options': 'DENY',
            'X-XSS-Protection': '1; mode=block',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains'
          };

          let clonedRequest = req.clone({
            setHeaders: securityHeaders
          });

          if (!(exludeFound && exludeFound.length > 0)) {
            if (req.method == "GET") {
              if (req.method === "GET" && environment.encryption) {
                clonedRequest = req;

                // Verificar si la URL es absoluta (http:// o https://)
                const isAbsoluteUrl = req.url.startsWith('http://') || req.url.startsWith('https://');
                
                // Si es una URL relativa (archivos estáticos como assets), no encriptar
                if (!isAbsoluteUrl) {
                  clonedRequest = req.clone({ setHeaders: securityHeaders });
                } else if (req.url.indexOf("?") > 0) {
                  const url = new URL(req.url);
                  const skipPathEncryption = this.shouldSkipPathIdEncryption(url.pathname);
                  url.searchParams.forEach((value, key) => {
                    if(this.isValidBase64(value)){
                      url.searchParams.set(key, value);
                    }else{
                      if (!this.encryptDecryptService.isEncrypted(value)) {
                        url.searchParams.set(key, this.base64UrlEncode(this.encryptDecryptService.encryptUsingAES256(value)));
                      }
                    }
                  });

                  const pathParts = url.pathname.split('/');
                  const apiIndex = pathParts.indexOf('api');
                  const encryptedParts = pathParts.map((part, index) => {
                    if (!skipPathEncryption && index > apiIndex && !isNaN(Number(part)) && !this.encryptDecryptService.isEncrypted(part)) {
                      return this.base64UrlEncode(this.encryptDecryptService.encryptUsingAES256(part));
                    }
                    return part;
                  });

                  url.pathname = encryptedParts.join('/');
                  clonedRequest = req.clone({ url: url.toString() });

                } else {
                  const urlParts = req.url.split('/');
                  const apiIndex = urlParts.indexOf('api');
                  const url = new URL(req.url);
                  const skipPathEncryption = this.shouldSkipPathIdEncryption(url.pathname);
                  const encryptedParts = urlParts.map((part, index) => {
                    if (!skipPathEncryption && index > apiIndex && !isNaN(Number(part)) && !this.encryptDecryptService.isEncrypted(part)) {
                      return this.base64UrlEncode(this.encryptDecryptService.encryptUsingAES256(part));
                    }
                    return part;
                  });
                  const encryptedURL = encryptedParts.join('/');
                  clonedRequest = req.clone({ url: encryptedURL,setHeaders: securityHeaders
                  });
                }

                return next.handle(clonedRequest).pipe(
                  map(event => this.handleResponse(event)),
                  catchError(err => this.handleError(err.error ? err.error : err))
                );
              }

              return next.handle(req).pipe(
                map(event => this.handleResponse(event)),
                catchError(err => this.handleError(err.error ? err.error : err))
              );
            } else if (req.method == "POST") {
              if (req.body || req.body?.length > 0) {
                const url = new URL(req.url);
                if (environment.encryption) {

                    const pathParts = url.pathname.split('/');
                    const apiIndex = pathParts.indexOf('api');
                    const encryptedParts = pathParts.map((part, index) => {
                      if (index > apiIndex && !isNaN(Number(part)) && !this.encryptDecryptService.isEncrypted(part)) {
                        return this.base64UrlEncode(this.encryptDecryptService.encryptUsingAES256(part));
                      }
                      return part;
                    });

                    url.pathname = encryptedParts.join('/');

                    url.searchParams.forEach((value, key) => {
                      if(!this.checkValidEncodeBase64AndEncript(value)){
                          if (!this.encryptDecryptService.isEncrypted(value)) {
                            url.searchParams.set(key, this.encryptDecryptService.encryptUsingAES256(value));
                          }
                      }
                    });
                }

                const clonedRequest = req.clone({ url: url.toString() });

                let cloneReq = this.procesarRequest(req, clonedRequest, environment);

                return next.handle(cloneReq).pipe(
                  map(event => this.handleResponse(event)),
                  catchError(err => this.handleError(err.error ? err.error : err))
                );
              }
              let data = req.body as FormData;
              return next.handle(req).pipe(
                map(event => this.handleResponse(event)),
                catchError(err => this.handleError(err.error ? err.error : err))
              );
            } else if (req.method == "PUT") {
              if (req.body || req.body?.length > 0) {

                const url = new URL(req.url);

                if (environment.encryption) {
                        const pathParts = url.pathname.split('/');
                        const apiIndex = pathParts.indexOf('api');
                        const encryptedParts = pathParts.map((part, index) => {
                          if (index > apiIndex && !isNaN(Number(part)) && !this.encryptDecryptService.isEncrypted(part)) {
                            return this.base64UrlEncode(this.encryptDecryptService.encryptUsingAES256(part));
                          }
                          return part;
                        });
                        url.pathname = encryptedParts.join('/');
                    url.searchParams.forEach((value, key) => {
                      if(!this.checkValidEncodeBase64AndEncript(value)){
                          if (!this.encryptDecryptService.isEncrypted(value)) {
                            url.searchParams.set(key, this.encryptDecryptService.encryptUsingAES256(value));
                          }
                      }
                    });
                }
                const clonedRequest = req.clone({ url: url.toString() });

                let cloneReq = this.procesarRequest(req, clonedRequest, environment);

                return next.handle(cloneReq).pipe(
                  map(event => this.handleResponse(event)),
                  catchError(err => this.handleError(err.error ? err.error : err))
                );

              }
              let data = req.body as FormData;
              return next.handle(clonedRequest);
            }else if (req.method == "DELETE") {
              if (environment.encryption) {
                if (req.url.indexOf("?") > 0) {
                  let encriptURL = req.url.substr(0, req.url.indexOf("?") + 1) + this.encryptDecryptService.encryptUsingAES256(req.url.substr(req.url.indexOf("?") + 1, req.url.length));
                  clonedRequest.clone({
                    url: encriptURL
                  });
                }
              }
              return next.handle(clonedRequest).pipe(
                map(event => this.handleResponse(event)),
                catchError(err => this.handleError(err.error?err.error:err))
              );
            }
          }
          return next.handle(clonedRequest);
      }


      private handleResponse(event: HttpEvent<any>): HttpEvent<any> {

        if (event instanceof HttpResponse && event.body && environment.encryption) {
          // Omitir desencriptado para respuestas binarias (Blob/ArrayBuffer)
          if (event.body instanceof Blob || event.body instanceof ArrayBuffer) {
            return event;
          }
          if (typeof event.body === 'string') {
            try {
              const parsedBody = JSON.parse(event.body);
              if (parsedBody?.result) {
                const decryptedBody = this.decryptResultBody(parsedBody.result);
                return event.clone({ body: decryptedBody });
              }
            } catch (error) {
              // Si no es JSON válido se mantiene como texto plano
            }
            return event;
          }
          if (typeof event.body !== 'object') {
            return event;
          }

          if (!event.body.result) {
            return event;
          }

          const decryptedBody = this.decryptResultBody(event.body.result);
          return event.clone({ body: decryptedBody });
        }
        return event;
      }

      private decryptResultBody(result: string): any {
        const resultDescrypted = this.encryptDecryptService.decryptUsingAES256(result);
        if (!this.isValidJson(resultDescrypted)) {
          return resultDescrypted;
        }

        const decryptedBody = JSON.parse(resultDescrypted);
        if (Array.isArray(decryptedBody.data)) {
          decryptedBody.data.forEach(item => {
            if (item.id) {
              item.id = this.base64UrlEncode(this.encryptDecryptService.encryptUsingAES256(item.id.toString()));
            }
          });
        } else if (decryptedBody.id) {
          decryptedBody.id = this.base64UrlEncode(this.encryptDecryptService.encryptUsingAES256(decryptedBody.id.toString()));
        }
        return decryptedBody;
      }


      private base64UrlEncode(str) {
        return btoa(str).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      }

      private base64UrlDecodeCustom(encodedStr) {
        let str = encodedStr.replace(/-/g, '+').replace(/_/g, '/');
        while (str.length % 4) {
          str += '=';
        }
        return atob(str);
      }

      isValidJson(cadena: string): boolean {
        try {
          JSON.parse(cadena);
          return true;
        } catch (error) {
          return false;
        }
      }



      isValidBase64(str: string): boolean {
        const regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
        if (!regex.test(str)) {
          return false;
        }
        try {
          const decodedStr = this.base64UrlDecodeCustom(str);
          const encodedStr = btoa(decodedStr).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
          return str === encodedStr;
        } catch (e) {
          return false;
        }
      }

      private handleError(err: any): Observable<never> {

        if (environment.encryption) {
           if(err.result){
              try {
                const decrypted = this.encryptDecryptService.decryptUsingAES256(err.result);
                if (decrypted) {
                  const decryptedBody = JSON.parse(decrypted);
                  return throwError(() => decryptedBody);
                }
              } catch (e) {
                // La desencriptación o el parseo falló (ej. respuesta binaria), propagar error original
              }
            }
        }
        return throwError(() => err);
      }

      private encryptIds(body: any): void {
        if (Array.isArray(body.data)) {
          body.data.forEach(item => {
            if (item.id) {
              item.id = encodeURIComponent(this.encryptDecryptService.encryptUsingAES256(item.id.toString()));
            }
          });
        } else if (body.id) {
          body.id = encodeURIComponent(this.encryptDecryptService.encryptUsingAES256(body.id.toString()));
        }
      }

      decryptJsonObject(jsonObj: any): any {

        Object.keys(jsonObj).forEach(key => {

          let value =jsonObj[key];

          if (this.checkValidEncodeBase64AndEncript(value)) {
            jsonObj[key] = this.encryptDecryptService.decryptUsingAES256(this.base64UrlDecodeCustom(value));
          } else if (typeof jsonObj[key] === 'object' && jsonObj[key] !== null) {
            jsonObj[key] = this.decryptJsonObject(jsonObj[key]);
          }

        });

        return jsonObj;
      }

      checkValidEncodeBase64AndEncript(str: string){
        if(this.isValidBase64(str)){
          let value = this.base64UrlDecodeCustom(str);
          if(this.encryptDecryptService.isEncrypted(value)){
            return true;
          }
        }
        return false;
      }


      procesarRequest(req: any, clonedRequest: any, environment: any) {
        let valorTxt: any = req.body;
        if (typeof req.body === 'object') {
          valorTxt = JSON.stringify(req.body);
        }
        let cloneReq = clonedRequest;
        if (req.body || req.body.length > 0) {
          if (environment.encryption) {
            let jsonObj = JSON.parse(valorTxt);

            jsonObj = this.decryptJsonObject(jsonObj);

            cloneReq = clonedRequest.clone({
              body: this.encryptDecryptService.encryptUsingAES256(JSON.stringify(jsonObj))
            });
          }
        }
        return cloneReq;
      }


}
